import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useSnapshot } from "valtio";
import { ModalBody } from "reactstrap";

import {
    setDataGeneral,
    setTicketHeaderSaleModeBold,
    setTicketHeaderSaleModeBlackBackround,
    setTicketHeaderName_phone_number_bold,
    setTicketHeaderLogoCustomer,
    setTicketHeaderLogoKitchen,
    StoreGeneral,
    setAutomaticPrintingNumberCustomer,
    setAutomaticPrintingNumberTickets,
    setPrinterInformationMode,
    setPrinterBold,
    setTicketHeaderStyleOrderNumber,
    setTicketHeaderPathCustomer,
    setTicketHeaderPathKitchen,
} from "@components/Common/PrinterSetting/stores";

import {
    PrinterRowData,
    PrinterGeneralBlock,
} from "@components/Common/PrinterSetting/types";

import UserCard from "./Hook/UserCard";

import "../index.css";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";

type GeneralPanelSettingType = {
    rowData: PrinterRowData;
};
export default function GeneralPanelSetting({
    rowData,
}: GeneralPanelSettingType) {
    const { t } = useTranslation();

    const {
        ticketHeaderSaleModeBlackBackround,
        NumberCustomer,
        NumberTicketsKitchen,
        ticketHeaderSaleModeBold,
        ticketHeaderName_phone_number_bold,
        ticketHeaderLogoCustomer,
        ticketHeaderLogoKitchen,
        printerBold,
        printerInformationMode,
        ticketHeaderPathCustomer,
        ticketHeaderPathKitchen,
        ticketHeaderStyleOrderNumber,
    } = useSnapshot(StoreGeneral);

    useEffect(() => {
        const general = rowData["general"];
        const ticketHeader = general?.ticket_header;
        if (ticketHeader) {
            setTicketHeaderSaleModeBold(ticketHeader.sale_mode_bold);
            setTicketHeaderSaleModeBlackBackround(
                ticketHeader.sale_mode_black_backround
            );
            setTicketHeaderName_phone_number_bold(
                ticketHeader.name_phone_number_bold
            );
            setTicketHeaderPathKitchen(ticketHeader.Path_kitchen);
            setTicketHeaderLogoCustomer(ticketHeader.logo_customer);
            setTicketHeaderLogoKitchen(ticketHeader.logo_kitchen);
            setTicketHeaderPathCustomer(ticketHeader.Path_customer);
            setTicketHeaderStyleOrderNumber(
                ticketHeader.ticketHeaderStyleOrderNumber
            );
        }
        const automaticPrinting = general?.automatic_printing;
        if (automaticPrinting?.NumberCustomer) {
            setAutomaticPrintingNumberCustomer(automaticPrinting.NumberCustomer);
        }
        if (automaticPrinting?.NumberTicketsKitchen) {
            setAutomaticPrintingNumberTickets(
                automaticPrinting.NumberTicketsKitchen
            );
        }
        const informationMode = general?.information_mode;
        if (informationMode) {
            setPrinterInformationMode(
                informationMode.printer_information_mode
            );
            setPrinterBold(informationMode.information_bold);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const data: PrinterGeneralBlock = {
            automatic_printing: {
                NumberCustomer,
                NumberTicketsKitchen,
            },
            ticket_header: {
                sale_mode_bold: ticketHeaderSaleModeBold,
                sale_mode_black_backround: ticketHeaderSaleModeBlackBackround,
                name_phone_number_bold: ticketHeaderName_phone_number_bold,
                logo_customer: ticketHeaderLogoCustomer,
                Path_customer: ticketHeaderPathCustomer,
                Path_kitchen: ticketHeaderPathKitchen,
                logo_kitchen: ticketHeaderLogoKitchen,
                ticketHeaderStyleOrderNumber: ticketHeaderStyleOrderNumber,
            },
            information_mode: {
                information_bold: printerBold,
                printer_information_mode: printerInformationMode,
            },
        };
        setDataGeneral(data);
    }, [
        printerBold,
        printerInformationMode,
        NumberCustomer,
        NumberTicketsKitchen,
        ticketHeaderSaleModeBold,
        ticketHeaderSaleModeBlackBackround,
        ticketHeaderLogoCustomer,
        ticketHeaderPathCustomer,
        ticketHeaderLogoKitchen,
        ticketHeaderPathKitchen,
        ticketHeaderName_phone_number_bold,
        ticketHeaderStyleOrderNumber,
    ]);

    return (
        <React.Fragment>
            <ModalBody style={{ height: "730px" }}>
                <div className="px-3 mt-2">
                    <h4 style={{ fontSize: "24px" }}>{t("General")}</h4>
                </div>
                <UserCard rowData={rowData} />
            </ModalBody>
        </React.Fragment>
    );
}
